import { css } from '@emotion/react';

const getAlwaysLightModeCss = css`
  color-scheme: only light;
  /* stylelint-disable-next-line cds-stylelint/cds-tokens-override */
  --cds-logo-wrapper-padding: 0;
`;

export default getAlwaysLightModeCss;
